import { ReactElement } from "react";

import { Anchor, TooltipDialog, Button } from "@newsela/angelou";

import { cellLinkCss } from "../Cells.style";

interface CellLinkListMoreProp {
  value: string[];
  href?: string;
  showTooltip?: boolean;
  tooltipValue?: string[];
}

const CellLinkListMore = ({
  value,
  href,
  showTooltip = false,
  tooltipValue,
}: CellLinkListMoreProp): ReactElement => {
  const tooltipData = tooltipValue || value;
  const count = value?.length;
  const tooltipCount = tooltipData?.length;
  const isLink = !!href;
  const hasMoreValues = tooltipCount > 1;
  const usefulValue = value?.[0];

  if (!count) return <span>-</span>;

  const displayText = hasMoreValues
    ? `${usefulValue || ""} & ${tooltipCount - 1} more`
    : usefulValue;

  const tooltipContent =
    hasMoreValues && showTooltip ? (
      <div style={{ padding: "8px" }}>
        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          {tooltipData.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    ) : null;

  if (isLink) {
    return (
      <Anchor
        href={href}
        __cssFor={{
          root: cellLinkCss,
        }}
      >
        {hasMoreValues && showTooltip ? (
          <TooltipDialog
            body={tooltipContent}
            placement="top"
            buttonContents={displayText}
            buttonProps={{
              flavor: Button.flavors.incognito,
            }}
          />
        ) : (
          <span>{displayText}</span>
        )}
      </Anchor>
    );
  }

  if (hasMoreValues && showTooltip) {
    return (
      <TooltipDialog
        body={tooltipContent}
        placement="top"
        buttonContents={displayText}
        buttonProps={{
          flavor: Button.flavors.incognito,
        }}
      />
    );
  }

  return <span>{displayText}</span>;
};

export default CellLinkListMore;
